import styled from '@emotion/styled';
import { Fragment, type FC } from 'react';

import { Item, type Props as ItemProps } from './item';

type Props = {
  className?: string;
  menus: ItemProps[];
};

export const MenuList: FC<Props> = ({ className, menus }) => (
  <Wrapper className={className || ''}>
    {menus.map((menu, index) => (
      <Fragment key={`header-menu-${index}`}>
        {index !== 0 && <Slash aria-hidden={true}>/</Slash>}
        <Item {...menu} />
      </Fragment>
    ))}
  </Wrapper>
);

const Slash = styled.li`
  margin-left: 0.3em;
  margin-right: 0.3em;
`;

const Wrapper = styled.ul`
  list-style: none;
  padding: 0;
  display: flex;
`;

export default MenuList;
